import { render, staticRenderFns } from "./undp-conversion.vue?vue&type=template&id=32a5a774&"
import script from "./undp-conversion.vue?vue&type=script&lang=js&"
export * from "./undp-conversion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a5a774')) {
      api.createRecord('32a5a774', component.options)
    } else {
      api.reload('32a5a774', component.options)
    }
    module.hot.accept("./undp-conversion.vue?vue&type=template&id=32a5a774&", function () {
      api.rerender('32a5a774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion/undp-conversion.vue"
export default component.exports